import * as React from 'react';
import { memo } from 'react';
import { Row, Col, Badge, Space } from 'antd';
import clsx from 'clsx';
import { NoContentArticle, Tag } from '../knowledge-base.type';
import TagIcon from '../../knowledge-base-common/components/tag-icon';

interface CategoryViewProps {
    tags: Tag[];
    selectTag: (tag: Tag) => void;
    articlesByTag: Map<string, NoContentArticle[]>;
}

const CategoryView = memo(({ tags, selectTag, articlesByTag }: CategoryViewProps) => {
    return (
        <Space
            size={18}
            direction="vertical"
        >
            <Row gutter={[20, 18]}>
                {Array.from(articlesByTag.entries())
                    .filter(([_, articles]) => articles.length > 0)
                    .map(([tagId, articles]) => {
                        const tag = tags.find((tag) => tag.id === tagId);
                        const articlesCount = articles.length;
                        if (!tag) {
                            return null;
                        }
                        return (
                            <Col key={tagId}>
                                <Badge.Ribbon
                                    text={articlesCount}
                                    color="#164B84"
                                    placement="start"
                                >
                                    <button
                                        onClick={(e: React.MouseEvent) => {
                                            if (
                                                (e.target as HTMLElement).closest('button') ===
                                                e.currentTarget
                                            )
                                                selectTag(tag);
                                        }}
                                        className={clsx(
                                            'button-card',
                                            'button-card__tag',
                                            'button-card__active'
                                        )}
                                    >
                                        <TagIcon
                                            name={tag.icon}
                                            size={45}
                                        />
                                        {tag.title}
                                    </button>
                                </Badge.Ribbon>
                            </Col>
                        );
                    })}
            </Row>
        </Space>
    );
});

export default CategoryView;
